import { useNetwork } from '@/presentation/context/network';
import YourItems from './YourItems';
import useAddress from '@/application/read/web3/useAddress';
import useBalances from '@/application/read/tokens/useBalances';
import useUserAssets from '@/application/read/assets/useUserAssets';
import { Address, Vault } from 'nftx.js';
import useCollection from '@/application/read/collections/useCollection';
import { useMemo } from 'react';
import ConnectButton from '@/presentation/components/widgets/ConnectButton';
import Icon, { Icons } from '@/presentation/components/elements/Icon';
import { getQueryStatus } from '@/infrastructure/utils/getLoadingState';

const YourItemsContainer = ({
  collectionAddress,
  vaults,
  selectedVault,
}: {
  collectionAddress?: Address;
  vaults?: Vault[];
  selectedVault: Vault | undefined;
}) => {
  const { slug } = useNetwork();
  const userAddress = useAddress();

  const { data: vTokens } = useBalances({ userAddress });
  const {
    data: collectionAssets,
    status,
    fetchStatus,
  } = useUserAssets({
    userAddress,
    assetAddress: collectionAddress,
    vaultId: selectedVault?.vaultId,
  });

  const { data: collection } = useCollection(collectionAddress);

  const vaultIds = useMemo(() => {
    if (selectedVault) {
      return [selectedVault.vaultId];
    }
    return vaults?.map((v) => v.vaultId);
  }, [selectedVault, vaults]);

  if (!userAddress) {
    return (
      <div className="p-6 flex justify-center">
        <ConnectButton />
      </div>
    );
  }

  if (!vaultIds || !vTokens || !collection || !collectionAssets) {
    return (
      <div className="p-6 flex justify-center">
        <Icon name={Icons.SPINNER_GAP} size={32} className="animate-spin" />
      </div>
    );
  }

  return (
    <YourItems
      slug={slug}
      vaultIds={vaultIds}
      collection={{
        ...collection,
        vTokens: vTokens?.filter((v) => vaultIds.includes(v.vaultId)),
      }}
      collectionAssets={collectionAssets}
      status={getQueryStatus(status, fetchStatus)}
    />
  );
};

export default YourItemsContainer;
